import { useNavigate } from "react-router-dom";
import { Route, Routes } from "react-router-dom";
import BuildingViewBuilding from "../components/BuildingView/BuildingViewBuilding";
import BuildingWizard from "./BuildingWizard";
import BuildingDetails from "../components/BuildingView/BuildingDetails";
import { useGlobalData } from "../components/GlobalDataProvider";
import styles from "./BuildingView.module.css";
import { Accordion, Card, Form } from "react-bootstrap";
import { ModuleTypeId } from "../types/DBTables";
import ToolTipBox from "../components/Global/Editors/ToolTipBox";
import { nameof } from "../components/Global/Utils";
import { MapTooltip } from "../types/globalData";
import { useEffect, useState } from "react";
import { get } from "../modules/server";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAdd, faCheck, faCircle, faCircleCheck, faCircleExclamation, faCircleQuestion, faEdit, faExclamation, faInfo, faInfoCircle } from "@fortawesome/free-solid-svg-icons";

// const iconNotStarted = faExclamation;
// const iconStarted = faEdit;
// const iconFinished = faCheck;

// const iconNotStarted = faCircle;
// const iconStarted = faCircle;
// const iconFinished = faCircle;

const iconNotStarted = faCircleExclamation;
const iconStarted = faCircleQuestion;
const iconFinished = faCircleCheck;
let defaultSelectedPeriod = ""; //Stores selected value between component mounts

const BuildingView = () => {
  const [subscriptionParams, setSubscriptionParams] = useState({} as any);
  const [roundStatuses, setRoundStatuses] = useState({} as any);
  const [roundPeriods, setRoundPeriods] = useState([] as any[]);
  const [selectedPeriod, setSelectedPeriod] = useState(defaultSelectedPeriod);

  const navigate = useNavigate();
  const globalData = useGlobalData();
  const user = globalData.user;

  useEffect(() => {
    const fetchSubscriptionParams = async () => {
      let subscriptionParams = {} as any;
      const response = await get("GetCurrentSubscription");
      if (response.success) {
        subscriptionParams["NoOfBuildings"] = response.subscription.noOfBuildings;
        subscriptionParams["TotalSurfaceArea"] = response.subscription.totalSurfaceArea;
      }
      const response2 = await get("GetCurrentHousingStock");
      if (response2.success) {
        subscriptionParams["NoOfBuildingsCurrent"] = response2.housingStock.noOfBuildings;
        subscriptionParams["TotalSurfaceAreaCurrent"] = response2.housingStock.totalSurfaceArea;
      }

      setSubscriptionParams(subscriptionParams);
    };
    fetchSubscriptionParams();
  }, [globalData.buildings]);

  useEffect(() => {
    const fetchGetRoundStatuses = async () => {
      if (!selectedPeriod) return;
      const response = await get("GetRoundStatuses/" + selectedPeriod);
      if (response.success) {
        setRoundStatuses(response.buildingStatusForPeriod);
      }
    };
    fetchGetRoundStatuses();
  }, [globalData, selectedPeriod]);

  useEffect(() => {
    const fetchRoundPeriods = async () => {
      const response = await get("GetRoundPeriods");
      if (response.success) {
        setRoundPeriods(response.periods.reverse());
        if (!selectedPeriod) {
          setSelectedPeriod(response.activePeriod);
          defaultSelectedPeriod = response.activePeriod;
        }
      }
    };
    fetchRoundPeriods();
  }, [globalData]);

  const getBuildingStatusWidget = (roundStatus: any) => {
    if (!roundStatus) return <FontAwesomeIcon icon={iconNotStarted} className="text-danger fs-5" title="Ej påbörjad" />;
    if (roundStatus.hasFinished) return <FontAwesomeIcon icon={iconFinished} className="text-success fs-5" title="Klar" />;
    if (roundStatus.hasDraft) return <FontAwesomeIcon icon={iconStarted} className="text-warning fs-5" title="Påbörjad" />;
    return <FontAwesomeIcon icon={iconNotStarted} className="text-danger fs-5" title="Ej påbörjad" />;
  };

  //

  const getAreaStatusWidget = (omr: string) => {
    const buildings = områden[omr];
    if (omr === "Beta 0.9 2024-07-17") {
      const roundStatusesForBuilding = {} as any;
      for (let b of buildings) {
        roundStatusesForBuilding[b.id] = roundStatuses[b.id];
      }
      const dbg = 5;
    }
    let status = "Ej påbörjad";
    let hasAnyDraft = false;
    let hasAllFinished = true;
    for (let b of buildings) {
      const roundStatus = roundStatuses[b.id];
      if (!roundStatus) {
        hasAllFinished = false;
      } else {
        if (!roundStatus.hasFinished) {
          hasAllFinished = false;
          if (roundStatus.hasDraft) {
            hasAnyDraft = true;
          }
        } else {
          hasAnyDraft = true;
        }
      }
    }
    if (hasAllFinished) {
      status = "Klar";
    } else if (hasAnyDraft) {
      status = "Påbörjad";
    }

    switch (status) {
      case "Ej påbörjad":
        return <FontAwesomeIcon icon={iconNotStarted} className="text-danger fs-5" title="Ej påbörjad" />;
      case "Påbörjad":
        return <FontAwesomeIcon icon={iconStarted} className="text-warning fs-5" title="Påbörjad" />;
      case "Klar":
        return <FontAwesomeIcon icon={iconFinished} className="text-success fs-5" title="Alla byggnader ronderade" />;
    }
  };

  const handlePeriodChanged = (e: any) => {
    var dbg = 5;
    setSelectedPeriod(e.target.value);
    defaultSelectedPeriod = e.target.value;
  };

  // <ul className="list-group list-group-flush align-items-middle">
  //   {områden[omr].map((b: any, i: number) => (
  //     <li key={b.id} className={"list-group-item " + styles.BuildingListItem}>
  //       {getBuildingStatusWidget(roundStatuses[b.id])}
  //       <BuildingViewBuilding building={b} onSelectBuilding={() => onSelectBuilding(b.id)} />
  //     </li>
  //   ))}

  //

  const områden = globalData.buildings?.reduce((res, b) => {
    const modByggnadsData = b.modules.find((m) => m.moduleTypeId === ModuleTypeId.Byggnadsdata);
    const byggnadsData = JSON.parse(modByggnadsData?.data ? modByggnadsData.data : "{}");
    const omr = byggnadsData?.område ? byggnadsData.område : " Inget område angivit";
    if (!res[omr]) res[omr] = [];
    res[omr].push(b);
    return res;
  }, {} as any);

  const useAccordion = globalData.buildings?.length && globalData.buildings.length > 8 && Object.keys(områden).length > 1;
  const kvarståendeByggnader = subscriptionParams.NoOfBuildings - subscriptionParams.NoOfBuildingsCurrent;

  const onSelectBuilding = (buildingId: number) => {
    navigate("" + buildingId);
  };

  const onSelectAddBuilding = () => {
    navigate("AddBuilding/1");
  };

  return (
    <>
      <Routes>
        <Route element={<BuildingWizard />} path="/AddBuilding/*" />
        <Route element={<BuildingDetails />} path="/:buildingId/*" />
        <Route
          element={
            <>
              <Card>
                <Card.Header className="p-6">
                  Byggnader
                  <div className="fs-6 fw-normal d-flex">
                    {roundPeriods && roundPeriods.length > 0 && (
                      <div className="row ">
                        <label className="col-lg-5 col-form-label d-none d-lg-flex">Visa status för:</label>
                        <div className="col-lg-7 ">
                          <Form.Select style={{ width: "auto" }} aria-label="Default select example" value={selectedPeriod} onChange={handlePeriodChanged}>
                            {roundPeriods.map((p) => (
                              <option key={p.name} value={p.name}>
                                {p.name}
                              </option>
                            ))}
                          </Form.Select>
                        </div>
                      </div>
                    )}
                  </div>
                  <div className="headerGroup">
                    <button type="button" className="btn btn-primary" onClick={() => PubSub.publish("ShowHelp", "help_Byggnader")}>
                      <FontAwesomeIcon icon={faInfoCircle} className="d-md-none" />
                      <span className="d-none d-md-inline">Hjälp</span>
                    </button>
                    {user?.roles?.Buildings && (
                      <div>
                        <ToolTipBox tooltipId={nameof<MapTooltip>("BTN_nyByggnad")} formatData={{ kvarståendeByggnader }}>
                          <button type="button" className="btn btn-primary" disabled={kvarståendeByggnader === 0} onClick={onSelectAddBuilding}>
                            <FontAwesomeIcon icon={faAdd} />
                            <span className="ms-2 d-none d-md-inline">Lägg till ny byggnad</span>
                          </button>
                        </ToolTipBox>
                        {/* <div className="fs-6 fw-normal">{"Kvarstående byggnader: " + kvarståendeByggnader}</div> */}
                      </div>
                    )}
                  </div>
                </Card.Header>
                <Card.Body>
                  {!globalData.buildings ? <div className="text-center">Laddar...</div> : <></>}
                  {globalData.buildings && globalData.buildings.length > 0 ? (
                    <>
                      {useAccordion ? (
                        <Accordion>
                          {Object.keys(områden)
                            .sort()
                            .map((omr, i) => (
                              <Accordion.Item key={omr} eventKey={i.toString()}>
                                <Accordion.Header>
                                  <div style={{ width: 30, textAlign: "center" }}>{getAreaStatusWidget(omr)}</div>
                                  {omr}
                                </Accordion.Header>
                                <Accordion.Body>
                                  <ul className="list-group list-group-flush align-items-middle">
                                    {områden[omr].map((b: any, i: number) => (
                                      <li key={b.id} className={"list-group-item " + styles.BuildingListItem}>
                                        <div style={{ position: "absolute", left: 80 }}>{getBuildingStatusWidget(roundStatuses[b.id])}</div>
                                        <BuildingViewBuilding building={b} onSelectBuilding={() => onSelectBuilding(b.id)} />
                                      </li>
                                    ))}
                                  </ul>
                                </Accordion.Body>
                              </Accordion.Item>
                            ))}
                        </Accordion>
                      ) : (
                        <ul className="list-group list-group-flush align-items-middle">
                          {globalData.buildings ? (
                            globalData.buildings.map((b, i) => (
                              <li key={b.id} className={"list-group-item " + styles.BuildingListItem}>
                                <div style={{ position: "absolute", left: 80 }}>{getBuildingStatusWidget(roundStatuses[b.id])}</div>
                                <BuildingViewBuilding building={b} onSelectBuilding={() => onSelectBuilding(b.id)} />
                              </li>
                            ))
                          ) : (
                            <></>
                          )}
                        </ul>
                      )}
                    </>
                  ) : (
                    <>
                      <h3>Välkommen till QWTOOL</h3>
                      <br />
                      Det finns ännu inga byggnader att visa - Klicka på knappen "Lägg till ny byggnad" för att skapa en ny byggnad och börja använda systemet !
                    </>
                  )}
                </Card.Body>
              </Card>
              {/* <div className="row d-flex align-items-center pb-4">
                <div className="col-8 fs-4 fw-bold">Byggnader</div>
                {user?.roles?.Buildings && (
                  <div className="col-4 d-flex justify-content-end">
                    <button type="button" className="btn btn-primary" onClick={onSelectAddBuilding}>
                      Lägg till ny byggnad
                    </button>
                  </div>
                )}
              </div>
              <ul className="list-group list-group-flush align-items-middle">
                {globalData.buildings ? (
                  globalData.buildings.map((b, i) => (
                    <li key={b.id} className={"list-group-item " + styles.BuildingListItem}>
                      <BuildingViewBuilding building={b} onSelectBuilding={() => onSelectBuilding(b.id)} />
                    </li>
                  ))
                ) : (
                  <></>
                )}
              </ul> */}
            </>
          }
          path="*"
        />
      </Routes>
    </>
  );
};

export default BuildingView;
